import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import { AiOutlineHistory, AiOutlineHome } from "react-icons/ai";
import { BiSearch, BiUserCircle } from "react-icons/bi";
import { BsBookmarkHeart } from "react-icons/bs";
import { MdOutlineExplore } from "react-icons/md";
import { LazyLoadImage } from "react-lazy-load-image-component";
import toast from "react-hot-toast";

const SidebarMini = () => {
  const location = useLocation();
  const currentUser = useAppSelector((state) => state.auth.user);
  const navigate = useNavigate();

  const personalPageHandler = (destinationUrl) => {
    if (!currentUser) {
      toast("You need to login to use this feature", {
        icon: "🔑",
      });

      return;
    }

    navigate(destinationUrl);
  };

  return (
    <div className="shrink-0 max-w-[80px] w-full py-8 flex flex-col items-center justify-between h-screen sticky top-0">
      <Link to="/">
        <LazyLoadImage
          alt="Logo"
          src="/logoicon.png"
          effect="opacity"
          className="w-10 h-10"
        />
      </Link>
      <div className="flex flex-col gap-7">
        <Link
          to="/"
          className={`transition duration-500  ${
            location.pathname === "/"
              ? "text-primary font-medium"
              : "hover:text-white"
          }`}
        >
          <AiOutlineHome size={25} />
        </Link>
        <Link
          to="/explore"
          className={`transition duration-500  ${
            location.pathname === "/explore"
              ? "text-primary font-medium"
              : "hover:text-white"
          }`}
        >
          <MdOutlineExplore size={25} />
        </Link>
        <Link
          to="/search"
          className={`transition duration-500  ${
            location.pathname === "/search"
              ? "text-primary font-medium"
              : "hover:text-white"
          }`}
        >
          <BiSearch size={25} />
        </Link>
        <button
          onClick={() => personalPageHandler("/watchlist")}
          className={`transition duration-500  ${
            location.pathname === "/"
              ? "text-primary font-medium"
              : "hover:text-white"
          }`}
        >
          <BsBookmarkHeart size={25} />
        </button>
        <button
          onClick={() => personalPageHandler("/history")}
          className={`transition duration-500  ${
            location.pathname === "/history"
              ? "text-primary font-medium"
              : "hover:text-white"
          }`}
        >
          <AiOutlineHistory size={25} />
        </button>
        <button
          onClick={() => personalPageHandler("/profile")}
          className={`transition duration-500  ${
            location.pathname === "/profile"
              ? "text-primary font-medium"
              : "hover:text-white"
          }`}
        >
          <BiUserCircle size={25} />
        </button>
      </div>
      <button onClick={() => personalPageHandler("/profile")}>
        <LazyLoadImage
          src={currentUser ? currentUser.photoURL : "/defaultAvatar.png"}
          alt="Avatar"
          effect="opacity"
          className="w-10 h-10 rounded-full"
        />
      </button>
    </div>
  );
};

export default SidebarMini;
